// import React, { useState, useEffect } from "react";
// import "./css/ProductReg.css";

// function ProductReg() {

//   const [currentTime, setCurrentTime] = useState(new Date());
//   const [text, setText] = useState(""); // State to hold the textarea value
//   const [remainingCharacters, setRemainingCharacters] = useState(500); // State to hold remaining characters
//   const [name, setName] = useState("");
//   const [address, setAddress] = useState("");
//   const [email, setEmail] = useState("");
//   const [phoneNumber, setPhoneNumber] = useState("");

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "name") setName(value);
//     else if (name === "address") setAddress(value);
//     else if (name === "email") setEmail(value);
//     else if (name === "phoneNumber") setPhoneNumber(value);
// };

// const handleSubmit = async () => {
//     const data = {
//         name: name,
//         address: address,
//         email: email,
//         phoneNumber: phoneNumber
//     };

//     try {
//         const response = await fetch("http://localhost:8888/ProductRegistration", {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json"
//             },
//             body: JSON.stringify(data)
//         });

//         if (response.ok) {
//             // //("Data submitted successfully");
//             // Optionally, reset the form fields here
//             setName("");
//             setAddress("");
//             setEmail("");
//             setPhoneNumber("");
//         } else {
//             console.error("Failed to submit data");
//         }
//     } catch (error) {
//         console.error("Error:", error);
//     }
// };


//   // Update the time every second
//   useEffect(() => {
//       const timerID = setInterval(() => {
//           setCurrentTime(new Date());
//       }, 1000);

//       // Clear the interval when component unmounts
//       return () => clearInterval(timerID);
//   }, []); // Empty dependency array to run this effect only once on component mount

//   // Update remaining characters count
//   useEffect(() => {
//       setRemainingCharacters(500 - text.length);
//   }, [text]);

//   // Update the time every second
//   useEffect(() => {
//       const timerID = setInterval(() => {
//           setCurrentTime(new Date());
//       }, 1000);

//       // Clear the interval when component unmounts
//       return () => clearInterval(timerID);
//   }, []); // Empty dependency array to run this effect only once on component mount

//   // Format the date and time in ISO 12-hour format
//   const formattedDate = currentTime.toLocaleString("en-US", {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "numeric",
//       minute: "numeric",
//       second: "numeric",
//       hour12: true,
//   });
//   // // //(formattedDate);
//   const handleInputChange = (e) => {
//       const value = e.target.value;
//       setText(value);
//   };
//   return (
//     <div className="ProductRegMainDiv">
//     <div className="ProductRegNavBar">
//         <div className="ProductRegNavBarLeftSide">
//             <div className="ProductRegSideBarImg">---</div>
//             <div className="ProductRegLogoText">SherDine</div>
//             <button className="ProductReButton">New Order</button>
//         </div>
//         <div className="ProductRegNavBarRightSide">{formattedDate}</div>
//     </div>

//     <div className="ProductRegMainPart">
//         <div className="ProductRegMainPartContents">
//             <div className="ProductRegMainPartContentsLeftSide">
//                 <div className="ProductRegLeftsideImgDiv">
//                     {/* <img className="ProductRegLeftsideImg" src={LeftSideImg} /> */}
//                 </div>
//             </div>
//             <div className="ProductRegMainPartContentsCenterSide">
//                 <div className="ProductRegMainPartContentsCenterSideInside">
//                     <div className="ProductRegCenterSideHeadingDiv">
//                         Product Registration
//                     </div>
//                     <div className="ProductRegCenterSideHeadingNameDiv">
//                         <div className="ProductRegCenterSideHeadingName">
//                             Name
//                         </div>
//                         <input className="InputNameProduct" />
//                     </div>
//                     <div className="AddressProduct">
//                         <div className="AddressTextProduct">
//                             Address
//                         </div>
//                         <textarea
//                             className="AddressInputBoxProduct"
//                             value={text}
//                             onChange={handleInputChange}
//                             maxLength={5000}
//                             id="student_detail"
//                         />
//                     </div>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Email
//                         </div>
//                         <input className="InputEmailBox" />
//                     </div>
//                     <div className="MobProduct">
//                         <div className="MobTextProduct">
//                             Phone Number
//                         </div>
//                         <input className="MobInputBox" />
//                     </div>
//                     <div className="SumbitButtonProRegDiv">
//                       <button className="SubmitButtonProReg">
//                         Submit
//                       </button>
//                     </div>
//                 </div>
//             </div>
//             <div className="ProductRegMainPartContentsRightSide">
//                 <div className="ProductRegRightSideImgDiv">
//                     {/* <img className="ProductRegRightSideImg" src={RightSideImg} /> */}
//                 </div>
//             </div>
//         </div>
//     </div>
// </div>  )
// }

// export default ProductReg


// import React, { useState, useEffect } from "react";
// import "./css/ProductReg.css";

// function ProductReg() {
//     const [currentTime, setCurrentTime] = useState(new Date());
//     const [name, setName] = useState("");
//     const [address, setAddress] = useState("");
//     const [email, setEmail] = useState("");
//     const [phoneNumber, setPhoneNumber] = useState("");

//     useEffect(() => {
//         const timerID = setInterval(() => {
//             setCurrentTime(new Date());
//         }, 1000);

//         return () => clearInterval(timerID);
//     }, []);

//     const formattedDate = currentTime.toLocaleString("en-US", {
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//     });

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "name") setName(value);
//         else if (name === "address") setAddress(value);
//         else if (name === "email") setEmail(value);
//         else if (name === "phoneNumber") setPhoneNumber(value);
//     };

//     const handleSubmit = async () => {
//         const data = {
//             name: name,
//             address: address,
//             email: email,
//             phoneNumber: phoneNumber
//         };

//         try {
//             const response = await fetch("http://localhost:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 // Optionally, reset the form fields here
//                 setName("");
//                 setAddress("");
//                 setEmail("");
//                 setPhoneNumber("");
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     return (
//         <div className="ProductRegMainDiv">
//             <div className="ProductRegNavBar">
//                 <div className="ProductRegNavBarLeftSide">
//                     <div className="ProductRegSideBarImg">---</div>
//                     <div className="ProductRegLogoText">SherDine</div>
//                     <button className="ProductReButton">New Order</button>
//                 </div>
//                 <div className="ProductRegNavBarRightSide">{formattedDate}</div>
//             </div>

//             <div className="ProductRegMainPart">
//                 <div className="ProductRegMainPartContents">
//                     <div className="ProductRegMainPartContentsLeftSide">
//                         <div className="ProductRegLeftsideImgDiv">
//                             {/* <img className="ProductRegLeftsideImg" src={LeftSideImg} /> */}
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsCenterSide">
//                         <div className="ProductRegMainPartContentsCenterSideInside">
//                             <div className="ProductRegCenterSideHeadingDiv">
//                                 Product Registration
//                             </div>
//                             <div className="ProductRegCenterSideHeadingNameDiv">
//                                 <div className="ProductRegCenterSideHeadingName">
//                                 Product Name
//                                 </div>
//                                 <input
//                                     className="InputNameProduct"
//                                     type="text"
//                                     name="name"
//                                     value={name}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="AddressProduct">
//                                 <div className="AddressTextProduct">
//                                     Product Item code
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="tel"
//                                     name="phoneNumber"
//                                     value={phoneNumber}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="EmailProduct">
//                                 <div className="EmailTextProduct">
//                                 Product Category
//                                 </div>
//                                 <input
//                                     className="InputEmailBox"
//                                     type="email"
//                                     name="email"
//                                     value={email}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                 Product Food type
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="tel"
//                                     name="phoneNumber"
//                                     value={phoneNumber}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                 Product Rate
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="tel"
//                                     name="phoneNumber"
//                                     value={phoneNumber}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="SumbitButtonProRegDiv">
//                                 <button
//                                     className="SubmitButtonProReg"
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsRightSide">
//                         <div className="ProductRegRightSideImgDiv">
//                             {/* <img className="ProductRegRightSideImg" src={RightSideImg} /> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default ProductReg;

// import { createRoot } from "react-dom/client";
// import React, { useState, useEffect } from "react";
// import "./css/ProductReg.css";

// function ProductReg() {
//     const [currentTime, setCurrentTime] = useState(new Date());
//     const [productName, setProductName] = useState("");
//     const [itemCode, setItemCode] = useState("");
//     const [category, setCategory] = useState("");
//     const [foodType, setFoodType] = useState("");
//     const [rate, setRate] = useState("");

//     useEffect(() => {
//         const timerID = setInterval(() => {
//             setCurrentTime(new Date());
//         }, 1000);

//         return () => clearInterval(timerID);
//     }, []);

//     const formattedDate = currentTime.toLocaleString("en-US", {
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//     });

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productName") setProductName(value);
//         else if (name === "itemCode") setItemCode(value);
//         else if (name === "category") setCategory(value);
//         else if (name === "foodType") setFoodType(value);
//         else if (name === "rate") setRate(value);
//     };

//     const handleSubmit = async () => {
//         const data = {
//             productName: productName,
//             itemCode: itemCode,
//             category: category,
//             foodType: foodType,
//             rate: rate
//         };
//         // //(data,"dt");

//         try {
//             const response = await fetch("http://192.168.29.85:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {  
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             //     body: JSON.stringify({
//             //         productName: productName,
//             // itemCode: itemCode,
//             // category: category,
//             // foodType: foodType,
//             // rate: rate
//             //     }),
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 // Optionally, reset the form fields here
//                 setProductName("");
//                 setItemCode("");
//                 setCategory("");
//                 setFoodType("");
//                 setRate("");
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     return (
//         <div className="ProductRegMainDiv">
//             <div className="ProductRegNavBar">
//                 <div className="ProductRegNavBarLeftSide">
//                     <div className="ProductRegSideBarImg">---</div>
//                     <div className="ProductRegLogoText">SherDine</div>
//                     <button className="ProductReButton">New Order</button>
//                 </div>
//                 <div className="ProductRegNavBarRightSide">{formattedDate}</div>
//             </div>

//             <div className="ProductRegMainPart">
//                 <div className="ProductRegMainPartContents">
//                     <div className="ProductRegMainPartContentsLeftSide">
//                         <div className="ProductRegLeftsideImgDiv">
//                             {/* <img className="ProductRegLeftsideImg" src={LeftSideImg} /> */}
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsCenterSide">
//                         <div className="ProductRegMainPartContentsCenterSideInside">
//                             <div className="ProductRegCenterSideHeadingDiv">
//                                 Product Registration
//                             </div>
//                             <div className="ProductRegCenterSideHeadingNameDiv">
//                                 <div className="ProductRegCenterSideHeadingName">
//                                     Product Name
//                                 </div>
//                                 <input
//                                     className="InputNameProduct"
//                                     type="text"
//                                     name="productName"
//                                     value={productName}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="AddressProduct">
//                                 <div className="AddressTextProduct">
//                                     Item Code
//                                 </div>
//                                 <input
//                                     className="AddressInputBoxProduct"
//                                     type="text"
//                                     name="itemCode"
//                                     value={itemCode}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="EmailProduct">
//                                 <div className="EmailTextProduct">
//                                     Category
//                                 </div>
//                                 <input
//                                     className="InputEmailBox"
//                                     type="text"
//                                     name="category"
//                                     value={category}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Food Type
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="text"
//                                     name="foodType"
//                                     value={foodType}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Rate
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="text"
//                                     name="rate"
//                                     value={rate}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="SumbitButtonProRegDiv">
//                                 <button
//                                     className="SubmitButtonProReg"
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsRightSide">
//                         <div className="ProductRegRightSideImgDiv">
//                             {/* <img className="ProductRegRightSideImg" src={RightSideImg} /> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default ProductReg;



// import { createRoot } from "react-dom/client";
// import React, { useState, useEffect } from "react";
// import "./css/ProductReg.css";

// function ProductReg() {
//     const [currentTime, setCurrentTime] = useState(new Date());
//     const [productName, setProductName] = useState("");
//     const [itemCode, setItemCode] = useState("");
//     const [category, setCategory] = useState("");
//     const [foodType, setFoodType] = useState("");
//     const [rate, setRate] = useState("");
//     const [categories, setCategories] = useState([]); // State to store categories
//     const [Variety, setVariety] = useState([]); // State to store categories

//     useEffect(() => {
//         const timerID = setInterval(() => {
//             setCurrentTime(new Date());
//         }, 1000);

//         return () => clearInterval(timerID);
//     }, []);
//     useEffect(() => {
//         // Fetch categories from the backend
//         fetch("http://192.168.29.85:8888/GetCategories")
//             .then((response) => response.json())
//             .then((CateData) => {
//                 // //(CateData); // Log the fetched categories to console
//                 setCategories(CateData); // Set the fetched categories in state
//             })
//             .catch((error) => console.error("Error fetching categories:", error));
//     }, []);
//     // useEffect(() => {
//     //     // Fetch categories from the backend
//     //     fetch("http://192.168.29.85:8888/RetreiveProduct")
//     //         .then((response) => response.json())
//     //         .then((ProData) => {
//     //             // //(ProData); // Log the fetched categories to console
//     //             setProducts(ProData); // Set the fetched categories in state
//     //         })
//     //         .catch((error) => console.error("Error fetching categories:", error));
//     // }, []);
//     const formattedDate = currentTime.toLocaleString("en-US", {
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//     });

//     const handleSubmit = async () => {
//         if (!productName || !itemCode || !category || !foodType || !rate) {
//             alert("Please fill in all fields.");
//             return;
//         }

//         if (isNaN(rate) || rate === "") {
//             alert("Rate should not be empty or must be a number.");
//             return;
//         }

//         const data = {
//             productName: productName,
//             itemCode: itemCode,
//             category: category,
//             foodType: foodType,
//             rate: rate
//         };

//         try {
//             // //("Try");
//             const response = await fetch("http://192.168.29.85:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 // Optionally, reset the form fields here
//                 setProductName("");
//                 setItemCode("");
//                 setCategory("");
//                 setFoodType("");
//                 setRate("");
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productName") setProductName(value);
//         else if (name === "itemCode") setItemCode(value);
//         else if (name === "category") setCategory(value);
//         else if (name === "foodType") setFoodType(value);
//         else if (name === "rate") setRate(value);
//     };

//     return (
//         <div className="ProductRegMainDiv">
//             <div className="ProductRegNavBar">
//                 <div className="ProductRegNavBarLeftSide">
//                     <div className="ProductRegSideBarImg">---</div>
//                     <div className="ProductRegLogoText">SherDine</div>
//                     <button className="ProductReButton">New Order</button>
//                 </div>
//                 <div className="ProductRegNavBarRightSide">{formattedDate}</div>
//             </div>

//             <div className="ProductRegMainPart">
//                 <div className="ProductRegMainPartContents">
//                     <div className="ProductRegMainPartContentsLeftSide">
//                         <div className="ProductRegLeftsideImgDiv">
//                             {/* <img className="ProductRegLeftsideImg" src={LeftSideImg} /> */}
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsCenterSide">
//                         <div className="ProductRegMainPartContentsCenterSideInside">
//                             <div className="ProductRegCenterSideHeadingDiv">
//                                 Product Registration
//                             </div>
//                             <div className="ProductRegCenterSideHeadingNameDiv">
//                                 <div className="ProductRegCenterSideHeadingName">
//                                     Product Name
//                                 </div>
//                                 <input
//                                     className="InputNameProduct"
//                                     type="text"
//                                     name="productName"
//                                     value={productName}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="AddressProduct">
//                                 <div className="AddressTextProduct">
//                                     Item Code
//                                 </div>
//                                 <input
//                                     className="AddressInputBoxProduct"
//                                     type="text"
//                                     name="itemCode"
//                                     value={itemCode}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="EmailProduct">
//                                 <div className="EmailTextProduct">
//                                     Category
//                                 </div>
//                                 <select
//                                     className="InputEmailBox"
//                                     name="category"
//                                     value={category}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select Category</option>
//                                     {/* Map through categories and create options */}
//                                     {categories.map((CateData) => (
//                                         <option key={CateData.category_id} value={CateData.Category_id
//                                         }>
//                                             {CateData.Category_Name
//                                             }
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             {/* <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Food Type
//                                 </div>
//                                 <select
//                                     className="MobInputBox"
//                                     type="text"
//                                     name="foodType"
//                                     value={foodType}
//                                     onChange={handleInputChange}
//                                 >
//                                     <options value="Non Veg">
//                                         Non Veg
//                                     </options>
//                                     <options value="veg">
//                                         Veg
//                                     </options>
//                                     </select>
//                             </div> */}
//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Food Type
//                                 </div>
//                                 <select
//                                     className="MobInputBox"
//                                     name="foodType"
//                                     value={foodType}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select Category</option>
//                                     <option value="Non Veg">Non-Veg</option>
//                                     <option value="Veg">Veg</option>
//                                 </select>
//                             </div>

//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Rate
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="text"
//                                     name="rate"
//                                     value={rate}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="VarietyText">
//                                 <div className="VarietyTextProduct">
//                                 Variety Of Product
//                                 </div>
//                                 <input
//                                     className="VarietyInputBoxProduct"
//                                     type="text"
//                                     name="Variety"
//                                     value={Variety}
//                                     onChange={handleInputChange}
//                                 />
//                                 +
//                             </div>
//                             <div className="SumbitButtonProRegDiv">
//                                 <button
//                                     className="SubmitButtonProReg"
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsRightSide">
//                         <div className="ProductRegRightSideImgDiv">
//                             {/* <img className="ProductRegRightSideImg" src={RightSideImg} /> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default ProductReg;

// import { createRoot } from "react-dom/client";
// import React, { useState, useEffect } from "react";
// import "./css/ProductReg.css";

// function ProductReg() {
//     const [currentTime, setCurrentTime] = useState(new Date());
//     const [productName, setProductName] = useState("");
//     const [itemCode, setItemCode] = useState("");
//     const [category, setCategory] = useState("");
//     const [foodType, setFoodType] = useState("");
//     const [rate, setRate] = useState("");
//     const [categories, setCategories] = useState([]); 
//     const [Varients, setVarients] = useState([]); // State to store product Varients

//     useEffect(() => {
//         const timerID = setInterval(() => {
//             setCurrentTime(new Date());
//         }, 1000);

//         return () => clearInterval(timerID);
//     }, []);
    
//     useEffect(() => {
//         // Fetch categories from the backend
//         fetch("http://192.168.29.85:8888/GetCategories")
//             .then((response) => response.json())
//             .then((CateData) => {
//                 // //(CateData); 
//                 setCategories(CateData); 
//             })
//             .catch((error) => console.error("Error fetching categories:", error));
//     }, []);

//     const formattedDate = currentTime.toLocaleString("en-US", {
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//     });

//     const handleAddVariety = () => {
//         setVarients([...Varients, { variety: "" }]);
//     };

//     const handleVarietyChange = (index, value) => {
//         const newVarients = [...Varients];
//         newVarients[index].variety = value;
//         setVarients(newVarients);
//     };

//     const handleSubmit = async () => {
//         if (!productName || !itemCode || !category || !foodType || !rate) {
//             alert("Please fill in all fields.");
//             return;
//         }

//         if (isNaN(rate) || rate === "") {
//             alert("Rate should not be empty or must be a number.");
//             return;
//         }

//         const data = {
//             productName: productName,
//             itemCode: itemCode,
//             category: category,
//             foodType: foodType,
//             rate: rate,
//             Varients: Varients.filter(v => v.variety !== "") // Only include non-empty Varients
//         };

//         try {
//             // //("Try");
//             const response = await fetch("http://192.168.29.85:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 // Optionally, reset the form fields here
//                 setProductName("");
//                 setItemCode("");
//                 setCategory("");
//                 setFoodType("");
//                 setRate("");
//                 setVarients([]);
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productName") setProductName(value);
//         else if (name === "itemCode") setItemCode(value);
//         else if (name === "category") setCategory(value);
//         else if (name === "foodType") setFoodType(value);
//         else if (name === "rate") setRate(value);
//     };

//     return (
//         <div className="ProductRegMainDiv">
//             <div className="ProductRegNavBar">
//                 <div className="ProductRegNavBarLeftSide">
//                     <div className="ProductRegSideBarImg">---</div>
//                     <div className="ProductRegLogoText">SherDine</div>
//                     <button className="ProductReButton">New Order</button>
//                 </div>
//                 <div className="ProductRegNavBarRightSide">{formattedDate}</div>
//             </div>

//             <div className="ProductRegMainPart">
//                 <div className="ProductRegMainPartContents">
//                     <div className="ProductRegMainPartContentsLeftSide">
//                         <div className="ProductRegLeftsideImgDiv">
//                             {/* <img className="ProductRegLeftsideImg" src={LeftSideImg} /> */}
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsCenterSide">
//                         <div className="ProductRegMainPartContentsCenterSideInside">
//                             <div className="ProductRegCenterSideHeadingDiv">
//                                 Product Registration
//                             </div>
//                             <div className="ProductRegCenterSideHeadingNameDiv">
//                                 <div className="ProductRegCenterSideHeadingName">
//                                     Product Name
//                                 </div>
//                                 <input
//                                     className="InputNameProduct"
//                                     type="text"
//                                     name="productName"
//                                     value={productName}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="AddressProduct">
//                                 <div className="AddressTextProduct">
//                                     Item Code
//                                 </div>
//                                 <input
//                                     className="AddressInputBoxProduct"
//                                     type="text"
//                                     name="itemCode"
//                                     value={itemCode}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>
//                             <div className="EmailProduct">
//                                 <div className="EmailTextProduct">
//                                     Category
//                                 </div>
//                                 <select
//                                     className="InputEmailBox"
//                                     name="category"
//                                     value={category}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select Category</option>
//                                     {categories.map((CateData) => (
//                                         <option key={CateData.category_id} value={CateData.Category_id}>
//                                             {CateData.Category_Name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
                          
//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Food Type
//                                 </div>
//                                 <select
//                                     className="MobInputBox"
//                                     name="foodType"
//                                     value={foodType}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select Category</option>
//                                     <option value="Non Veg">Non-Veg</option>
//                                     <option value="Veg">Veg</option>
//                                 </select>
//                             </div>

//                             <div className="MobProduct">
//                                 <div className="MobTextProduct">
//                                     Rate
//                                 </div>
//                                 <input
//                                     className="MobInputBox"
//                                     type="text"
//                                     name="rate"
//                                     value={rate}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>

//                             <div className="VarietyText">
//                                 <div className="VarietyTextProduct">
//                                     Variety Of Product
//                                 </div>
//                                 <button className="AddVarietyButton" onClick={handleAddVariety}>+</button>
//                             </div>
//                             {Varients.map((variety, index) => (
//                                 <div key={index} className="VarietyInputContainer">
//                                     <input
//                                         className="VarietyInputBoxProduct"
//                                         type="text"
//                                         name={`variety_${index}`}
//                                         value={variety.variety}
//                                         onChange={(e) => handleVarietyChange(index, e.target.value)}
//                                     />
//                                 </div>
//                             ))}
//                             <div className="SumbitButtonProRegDiv">
//                                 <button
//                                     className="SubmitButtonProReg"
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="ProductRegMainPartContentsRightSide">
//                         <div className="ProductRegRightSideImgDiv">
//                             {/* <img className="ProductRegRightSideImg" src={RightSideImg} /> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default ProductReg;


import { createRoot } from "react-dom/client";
import React, { useState, useEffect } from "react";
import "./css/ProductReg.css";

function ProductReg() {
    const [currentTime, setCurrentTime] = useState(new Date());
    const [productName, setProductName] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [category, setCategory] = useState("");
    const [foodType, setFoodType] = useState("");
    const [rate, setRate] = useState("");
    const [categories, setCategories] = useState([]);
    const [Database, setDatabase] = useState(localStorage.getItem('DB'));
    const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const [Varients, setVarients] = useState([{ variety: "", rate: "" }]);
    const api_base_url = process.env.REACT_APP_API_BASE_URL

    useEffect(() => {
        const timerID = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timerID);
    }, []);
    
    useEffect(() => {
        // Fetch categories from the backend
        fetch(`${api_base_url}/GetCategories/${Database}`)
            .then((response) => response.json())
            .then((CateData) => {
                // //(CateData); 
                setCategories(CateData); 
            })
            .catch((error) => console.error("Error fetching categories:", error));
    }, []);

    const formattedDate = currentTime.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
    });

    const handleAddVariety = () => {
        setVarients([...Varients, { variety: "", rate: "" }]);
    };

    const handleVarietyChange = (index, value) => {
        const newVarients = [...Varients];
        newVarients[index].variety = value;
        setVarients(newVarients);
    };

    const handleRateChange = (index, value) => {
        const newVarients = [...Varients];
        newVarients[index].rate = value;
        setVarients(newVarients);
    };
    // there is backup code in backup.md(1)
    const handleSubmit = async () => {
        if (!productName || !itemCode || !category || !foodType) {
            alert("Please fill in all fields.");
            return;
        }
    
        // const mainRate = Varients.length === 1 && Varients[0].variety === "" ? rate : Varients[0].rate;
        const mainRate = Varients.length === 1 && Varients[0].variety === "" ? rate : "";

        // if (isNaN(mainRate) || mainRate === "") {
        //     alert("Rate should not be empty or must be a number.");
        //     return;
        // }
        if (Varients.length === 1 && Varients[0].variety === "" && (isNaN(rate) || rate === "")) {
            alert("Rate should not be empty or must be a number.");
            return;
        }
        const data = {
            productName: productName,
            itemCode: itemCode,
            category: category,
            foodType: foodType,
            // rate: mainRate,
            Varients: Varients.filter(v => v.variety !== "") // Only include non-empty Varients
        };
        if (mainRate !== "") {
            data.rate = mainRate;
        }
        // //(data);
        try {
            const response = await fetch(`${api_base_url}/ProductRegistration/${Database}`, { 
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
    
            if (response.ok) {
                // //("Data submitted successfully");
                setProductName("");
                setItemCode("");
                setCategory("");
                setFoodType("");
                setRate("");
                setVarients([{ variety: "", rate: "" }]);
            } else if (response.status === 409) {
                console.error("Duplicate entry detected.");
                alert("A product with this name already exists.");
            } else {
                console.error("Failed to submit data");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "productName") setProductName(value);
        else if (name === "itemCode") setItemCode(value);
        else if (name === "category") setCategory(value);
        else if (name === "foodType") setFoodType(value);
        else if (name === "rate") setRate(value);
    };

    return (
        <div className="ProductRegMainDiv">
            <div className="ProductRegNavBar">
                <div className="ProductRegNavBarLeftSide">
                    <div className="ProductRegSideBarImg">---</div>
                    <div className="ProductRegLogoText">SherDine</div>
                    <button className="ProductReButton">New Order</button>
                </div>
                <div className="ProductRegNavBarRightSide">{formattedDate}</div>
            </div>

            <div className="ProductRegMainPart">
                <div className="ProductRegMainPartContents">
                    <div className="ProductRegMainPartContentsLeftSide">
                        <div className="ProductRegLeftsideImgDiv">
                            {/* <img className="ProductRegLeftsideImg" src={LeftSideImg} /> */}
                        </div>
                    </div>
                    <div className="ProductRegMainPartContentsCenterSide">
                        <div className="ProductRegMainPartContentsCenterSideInside">
                            <div className="ProductRegCenterSideHeadingDiv">
                                Product Registration
                            </div>
                            <div className="ProductRegCenterSideHeadingNameDiv">
                                <div className="ProductRegCenterSideHeadingName">
                                    Product Name
                                </div>
                                <input
                                    className="InputNameProduct"
                                    type="text"
                                    name="productName"
                                    value={productName}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="AddressProduct">
                                <div className="AddressTextProduct">
                                    Item Code
                                </div>
                                <input
                                    className="AddressInputBoxProduct"
                                    type="text"
                                    name="itemCode"
                                    value={itemCode}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="EmailProduct">
                                <div className="EmailTextProduct">
                                    Category
                                </div>
                                <select
                                    className="InputEmailBox"
                                    name="category"
                                    value={category} 
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Category</option>
                                    {categories.map((CateData) => (
                                        <option key={CateData.category_id} value={CateData.Category_id}>
                                            {CateData.Category_Name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                          
                            <div className="MobProduct">
                                <div className="MobTextProduct">
                                    Food Type
                                </div>
                                <select
                                    className="MobInputBox"
                                    name="foodType"
                                    value={foodType}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Category</option>
                                    <option value="Non Veg">Non-Veg</option>
                                    <option value="Veg">Veg</option>
                                </select>
                            </div>

                            {Varients.length === 1 && Varients[0].variety === "" ? (
                                <div className="MobProduct">
                                    <div className="MobTextProduct">
                                        Rate
                                    </div>
                                    <input
                                        className="MobInputBox"
                                        type="text"
                                        name="rate"
                                        value={rate}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            ) : (
                                Varients.map((variety, index) => (
                                    <div key={index} className="VarietyInputContainer">
                                        <div className="VarietyTextProduct">Variety {index + 1}</div>
                                        <input
                                            className="VarietyInputBoxProduct"
                                            type="text"
                                            name={`variety_${index}`}
                                            value={variety.variety}
                                            onChange={(e) => handleVarietyChange(index, e.target.value)}
                                        />
                                        <div className="MobTextProduct">Rate</div>
                                        <input
                                            className="VarietyInputBoxProduct"
                                            type="text"
                                            name={`rate_${index}`}
                                            value={variety.rate}
                                            onChange={(e) => handleRateChange(index, e.target.value)}
                                        />
                                    </div>
                                ))
                            )}

                            <div className="VarietyText">
                                <div className="VarietyTextProduct">
                                    Variety Of Product
                                </div>
                                <button className="AddVarietyButton" onClick={handleAddVariety}>+</button>
                            </div>
                            <div className="SumbitButtonProRegDiv">
                                <button
                                    className="SubmitButtonProReg"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="ProductRegMainPartContentsRightSide">
                        <div className="ProductRegRightSideImgDiv">
                            {/* <img className="ProductRegRightSideImg" src={RightSideImg} /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductReg;
